__turbopack_context__.v({
  "bold": "Heading-module__W48akG__bold",
  "centerText": "Heading-module__W48akG__centerText",
  "extrabold": "Heading-module__W48akG__extrabold",
  "font-2xl": "Heading-module__W48akG__font-2xl",
  "font-5xl": "Heading-module__W48akG__font-5xl",
  "font-bigtitle2": "Heading-module__W48akG__font-bigtitle2",
  "font-bigtitle3": "Heading-module__W48akG__font-bigtitle3",
  "font-headline": "Heading-module__W48akG__font-headline",
  "font-large-title": "Heading-module__W48akG__font-large-title",
  "font-subheadline": "Heading-module__W48akG__font-subheadline",
  "font-title1": "Heading-module__W48akG__font-title1",
  "font-title2": "Heading-module__W48akG__font-title2",
  "font-title3": "Heading-module__W48akG__font-title3",
  "heading": "Heading-module__W48akG__heading",
  "light": "Heading-module__W48akG__light",
  "medium": "Heading-module__W48akG__medium",
  "regular": "Heading-module__W48akG__regular",
  "semibold": "Heading-module__W48akG__semibold",
});
